export default __webpack_public_path__ + "static/media/pistbar.89e0bddd.png";